<div class="order-detail">
  <!--    PREDCHOZI OBJEDNAVKY NEUKAZUJEME U NOVEHO-->
  <!--    @if (mode() === 'detail') {-->
  @if (previousOrders.isLoading()) {
    <cue-loading />
  }
  @if (!previousOrders.isLoading() && !previousOrders.error()) {
    @for (x of data(); track x.resourceAttendee.resource.idForFiltering) {
      <h2 class="resource-title">{{ x.resourceAttendee.resource | resourceTitle }}</h2>

      @if (x.previousOrders.length === 0 && state() !== 'edit') {
        <div class="no-orders">
          <img src="assets/images/not-found/order-not-found.svg" />
          <p>
            {{ translation.notFound.orderNotFound | transloco }}
          </p>
        </div>
      }

      @if (x.previousOrders.length > 0) {
        <div class="expansionpanel-wrapper">
          @for (order of x.previousOrders; track order) {
            <kendo-expansionpanel class="show-panel">
              <ng-template kendoExpansionPanelTitleDirective>
                <div class="expansionpanel-title space-between">
                  {{ order.requestCode }}
                  <div class="end-part count">
                    <span>
                      {{ order.created | dateFormat }}
                      {{ order.created | timeFormat }}
                    </span>
                  </div>
                </div>
              </ng-template>
              <div>
                @if (order.note !== null) {
                  <div class="description">
                    <p>
                      {{ order.note }}
                    </p>
                  </div>
                }

                @for (item of order.items; track item) {
                  <div class="order-item">
                    <div class="image-wrapper">
                      <img
                        [class.!object-cover]="getServiceInfo(item).imagePreferCover"
                        [ngStyle]="{
                          'object-position': getServiceInfo(item).imageObjectPosition,
                        }"
                        [src]="
                          getServiceInfo(item).imageUrl !== null && getServiceInfo(item).imageUrl !== ''
                            ? getServiceInfo(item).imageUrl
                            : 'assets/images/placeholder-order.svg'
                        "
                      />
                    </div>
                    <div class="text-wrapper">
                      <div class="item-heading">
                        <p>
                          {{ getServiceInfo(item).name | localizedString }}
                        </p>
                      </div>
                      <div class="item-inner-count">
                        @if (item.note) {
                          <span class="item-description">
                            {{ item.note }}
                          </span>
                        }
                        @if (!item.note) {
                          <span class="item-description no-description">
                            {{ translation.orders.noDescription | transloco }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </kendo-expansionpanel>
          }
        </div>
      }

      @if (state() === 'edit') {
        <div class="order-wrapper new-order">
          @if (x.formGroup.controls.items.controls.length === 0) {
            <h4>{{ translation.orders.newOrderTitle | transloco }}</h4>
            @if (x.orderServicesLoading) {
              <cue-loading />
            } @else if (!x.canAddOrders) {
              <p>{{ translation.newReservationUi.locationDetails.noOrderServices | transloco }}</p>
            } @else {
              <p>{{ translation.orders.newOrderInstruction | transloco }}</p>
            }
          }

          @for (orderControl of x.formGroup.controls.items.controls; track orderControl; let index = $index) {
            <ng-container [formGroup]="$any(orderControl)">
              <div class="order-item">
                <div class="image-wrapper">
                  <img
                    class="service-image"
                    [src]="orderControl.value.imageUrl ?? 'assets/images/placeholder-order.svg'"
                  />
                </div>
                <div class="text-wrapper">
                  <div class="item-heading">
                    <p>
                      {{ orderControl.value.name }}
                    </p>
                  </div>
                  <div class="item-inner-count">
                    @if (orderControl.value.noteAllowed) {
                      <textarea
                        cueRtl
                        formControlName="note"
                        [class.error]="orderControl.get('note').invalid"
                      ></textarea>
                      @if (orderControl.get('note').invalid) {
                        <p class="error">
                          {{
                            translation.orders.minimalLength
                              | transloco: { length: orderControl.get('noteMinLength').value }
                          }}
                        </p>
                      }
                    }
                  </div>
                </div>
                <div
                  class="delete-button"
                  (click)="remove(x.resourceAttendee.resource.idForFiltering, orderControl, index)"
                >
                  <cue-icon [icon]="ICONS.cueClose" />
                </div>
              </div>
            </ng-container>
          }

          @if (x.canAddOrders) {
            <div class="order-select">
              @if (x.adding) {
                <assist-service-select
                  type="event"
                  [eventDate]="eventDate()"
                  [resourceGuid]="x.resourceAttendee.resource.id"
                  [usedServiceIds]="usedServiceIds()[$index]"
                  (cancelled)="setAdding($index, false)"
                  (itemSelected)="onSelect($index, x.resourceAttendee.resource.idForFiltering, $event)"
                />
              }
            </div>

            @if (!x.adding) {
              <div class="add-item-button" (click)="setAdding($index, true)">
                <cue-icon [icon]="ICONS.cueAdd" />
                {{ translation.orders.addItem | transloco }}
              </div>
            }
          }

          @if (x.formGroup.controls.items.length > 0) {
            <div class="order-note">
              <h4>{{ translation.orders.note | transloco }}</h4>
              <textarea cueRtl [formControl]="x.formGroup.controls.note"> </textarea>
            </div>
          }
        </div>
      }
    }
  }
  <!--    }-->
</div>
